import { defineMessages } from 'react-intl';

export default defineMessages({
    policyDetailsTitle: {
        id: 'tfpa.policyChange.gateway.contacts.policyroles.Name',
        defaultMessage: 'Name',
    },
    policyDetailsTitle: {
        id: 'tfpa.policyChange.gateway.contacts.policyroles.FirstName',
        defaultMessage: 'First Name',
    },
    policyDetailsTitle: {
        id: 'tfpa.policyChange.gateway.contacts.policyroles.LastName',
        defaultMessage: 'Last Name',
    },
    changeButton: {
        id: 'tfpa.policyChange.gateway.contacts.Change',
        defaultMessage: 'Change',
    },
    cancelButton: {
        id: 'tfpa.policyChange.gateway.contacts.Cancel',
        defaultMessage: 'Cancel',
    },
    required: {
        id: 'tfpa.policyChange.gateway.contacts.This is a required field.',
        defaultMessage: 'This is a required field.'
    }
})